import React, { useEffect, useState } from "react";
import PageContainer from "../Layout/PageContainer";
import { useParams, useNavigate } from "react-router-dom";
import spaceService from "../../redux/services/space.service";
import storageTypeService from "../../redux/services/storageType.service";
import styles from "./styles/SpaceView.module.scss";
import "./styles/_upload-image.scss";
import "../../assets/style.css";
import {
  Col,
  Row,
  Card,
  CardBody,
  Button,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import { useDispatch } from "react-redux";
import { toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  showImageBackdrop,
  showVideoBackdrop,
} from "../../redux/actions/backdrops";
import { ADMIN_USER_EMAIL } from "../../constants";
import ToggleButton from "react-bootstrap/ToggleButton";
import ToggleButtonGroup from "react-bootstrap/ToggleButtonGroup";
import { faCheckSquare, faCoffee } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "react-bootstrap/Image";
import storageCategoryService from "../../redux/services/storageCategory.service";
import amenityService from "../../redux/services/amenity.service";
import StorageItemService from "../../redux/services/storageItem.service";
import { validate } from "../../helpers/validation";
import settingService from "../../redux/services/setting.service";
import { getSettingsConfig } from "../../helpers/getSettingsConfig";
import SpaceAddress from "./components/SpaceAddress";
import EditListingSpaceImageVideoUpload from "./components/EditListingSpaceImageVideoUpload";
import { validateSpaceAddressFields } from "./components/validateSpaceAddressFields";
import { getGeocode, getLatLng } from "use-places-autocomplete";
import { createSpacesValidationForm } from "../../schema/createSpacesValidationSchema";
import globalService from "../../redux/services/global.service";
import { isValidUpload } from "../../helpers/validUpload";
import AddSubSpace from "./components/AddSubSpaceModel";
import SpaceImageUpload from "./components/SpaceImageUpload";
import { BUSINESS_TYPES } from "../../constants/businessTypes";

toast.configure();

const propertyTypes = [
  { id: 0, name: "Residential" },
  // { id: 1, name: 'Apartment' },
  { id: 2, name: "Commercial" },
];

const accessFrequencyList = [
  { id: 0, label: "Daily" },
  { id: 1, label: "Weekly" },
  { id: 2, label: "Monthly" },
  { id: 3, label: "As agreed upon" },
];

const leaseOptions = [
  { id: 1, label: "Short-Term (1-6 months)" },
  { id: 2, label: "Medium-Term (6-12 months)" },
  { id: 3, label: "Long-Term (1+ years)" },
  { id: 4, label: "Flexible" },
];

const amenityOptions = [
  { id: 1, name: "Indoor" },
  { id: 2, name: "Outdoor" },
  { id: 3, name: "Climate Controlled" },
  { id: 4, name: "Smoke Free" },
  { id: 5, name: "Smoke Detectors" },
  { id: 6, name: "Private Entrance" },
  { id: 7, name: "Private Space" },
  { id: 8, name: "Locked Area" },
  { id: 9, name: "Pet Free" },
  { id: 10, name: "Security Camera Monitored" },
  { id: 11, name: "No Stairs" },
  { id: 12, name: "Lighting" },
  { id: 13, name: "Ventilation Facility" },
  { id: 14, name: "Pickup and Drop Services by Host" },
  { id: 15, name: "Alarm" },
  { id: 16, name: "Gated" },
  { id: 17, name: "EV charging" },
  { id: 18, name: "Bathroom" },
  { id: 19, name: "Electric outlets" },
  { id: 20, name: "Fence" },
  { id: 21, name: "Trash Area" },
  { id: 22, name: "Wash Area" },
  { id: 23, name: "Ice Machine" },
  { id: 24, name: "Roll-up Door" },
  { id: 25, name: "Drive-up Access" },
  { id: 26, name: "Access Code" },
  { id: 27, name: "Handcarts" },
  { id: 29, name: "On-site Manager" },
  { id: 30, name: "Handicap Access Units" },
];
const convertStringToInt = (stringValue) => {
  const intValue = parseInt(stringValue, 10);
  return intValue;
};

const getCoordinates = async (address) => {
  // addressOne validation is handling by field level validation.

  if (address !== "") {
    try {
      const geocodeResults = await getGeocode({ address });
      if (geocodeResults.length === 0) {
        throw new Error("No geocode results found.");
      }
      const latLng = await getLatLng(geocodeResults[0]);
      return latLng;
    } catch (error) {
      return null;
    }
  }
};

export default function EditListing() {
  const [settings, setSettings] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [space, setSpace] = useState({});
  const [loading, setLoading] = useState(false);
  const [storageTypes, setStorageTypes] = useState([]);
  const [storageCategories, setStorageCategories] = useState([]);
  const [claimListing, setClaimListing] = useState(false);
  const [formData, setFormData] = useState({
    spaceMedia: null,
    stateCode: "",
    addressOne: "",
    addressTwo: "",
    city: "",
    quantity: 1,
    zipCode: "",
    latitude: 0.0,
    longitude: 0.0,
    spaceHeight: "",
    spaceWidth: "",
    spaceLength: "",
    propertyType: "",
    businessType: "",
    nearbyLandmark: "",
    storageTypeId: "",
    title: "",
    description: "",
    weeklyRate: "",
    monthlyRate: "",
    dailyRate: "",
    spaceAmenities: [],
    spaceStorageItems: [],
    accessFrequency: "",
    approvalOnVisit: null,
    countryId: 226,
    discountForFirstMonth: false,
    isPermissionAgreed: false,
    listedFrom: 0,
    status: null,
    floorLoadCapacity: "",
    accessPoints: "",
    loadingDocks: "",
    clearanceHeight: "",
    permissibleUses: "",
    leaseOptions: "",
    area: "",
    availableArea: "",
    minimumLeaseableArea: "",
    pricePerSqFt: "",
    isAffiliateSpace: 0,
    affiliateUrl: null,
  });
  const [amenities, setAmenities] = useState([]);
  const [vehicleType, setVehicleType] = useState([]);
  const [selectedImageVideoPreviews, setSelectedImageVideoPreviews] = useState(
    []
  );
  const [formError, setFormError] = useState({});
  const [isClearField, setIsClearField] = useState(false);
  const [isNeedToPrefil, setIsNeedToPrefil] = useState(false);
  const [spaceInfo, setSpaceInfo] = useState("");

  // const [isSubmitForReviewLoading, setIsSubmitForReviewLoading] = useState(false);
  // const [isSubmitSaveAsDraftLoading, setIsSubmitSaveAsDraftLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [mySpaceId, setMySpaceId] = useState(null);
  const [removeMedia, setRemoveMedia] = useState([]);
  const [isDisabledEverything, setIsDisabledEverything] = useState(false);

  // address field start
  const [addressErrors, setAddressErrors] = useState({});
  const [uspsError, setUspsError] = useState("");
  const [addressInvalidError, setAddressInvalidError] = useState("");
  const [isPrepopulated, setIsPrepopulated] = useState(true);

  const [refresh, setRefresh] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const addhandleOpenModal = () => setIsModalOpen(true);
  const addhandleCloseModal = () => setIsModalOpen(false);

  const { id } = useParams();

  useEffect(() => {
    if (!/\d+/.test(id)) {
      navigate(-1);
    }
  }, [id, navigate]);

  const [value, setValue] = useState([1]);

  const handleChange = (val) => setValue(val);

  const handleSelectFile = (e) => {
    // now adding new selected files
    const selectedFiles = e.target.files;

    const selectedFilesArray = Array.from(selectedFiles);

    // now adding files
    if (selectedFilesArray.length === 0) return;
    setFormData((prev) => ({
      ...prev,
      spaceMedia: prev.spaceMedia
        ? [...prev.spaceMedia, ...selectedFilesArray]
        : [...selectedFilesArray],
    }));
    const filesArray = selectedFilesArray.map((file) => {
      return {
        blobUrl: URL.createObjectURL(file),
        size: file.size,
        type: file.type,
        name: file.name,
      };
    });
    // const filesLength = filesArray.length + selectedImageVideoPreviews.length;
    setSelectedImageVideoPreviews((prev) => [...prev, ...filesArray]);
    // setSelectedImageVideoPreviewsLength(filesLength);
  };

  // pre select amenities
  const getAmenitiesToBePreSelected = (
    amenitiesFromBackend,
    stateSpaceAmenities
  ) => {
    const tempAmenitiesFromBackend = [...amenitiesFromBackend];
    const tempStateSpaceAmenities = [...stateSpaceAmenities];
    for (let i = 0; i < tempStateSpaceAmenities.length; i++) {
      for (let j = 0; j < tempAmenitiesFromBackend.length; j++) {
        if (tempStateSpaceAmenities[i].id === tempAmenitiesFromBackend[j].id) {
          tempStateSpaceAmenities[i] = {
            isChecked: true,
            id: tempStateSpaceAmenities[i].id,
          };
        }
      }
    }
    return tempStateSpaceAmenities; // to be saved to state
  };

  // pre select Storage Item
  const getVehicleTypeToBePreSelected = (
    storageItemFromBackend,
    stateSpaceStorageItems
  ) => {
    const tempStorageItemsFromBackend = [...storageItemFromBackend];
    const tempStateSpaceStorageItems = [...stateSpaceStorageItems];
    for (let i = 0; i < tempStateSpaceStorageItems.length; i++) {
      for (let j = 0; j < tempStorageItemsFromBackend.length; j++) {
        if (
          tempStateSpaceStorageItems[i].id === tempStorageItemsFromBackend[j].id
        ) {
          tempStateSpaceStorageItems[i] = {
            isChecked: true,
            id: tempStateSpaceStorageItems[i].id,
          };
        }
      }
    }
    return tempStateSpaceStorageItems; // to be saved to state
  };

  // populate video and image previews
  const handlePopulateImageVideoPreview = (images, video) => {
    // used to populate preview on fetch spaceInfo
    let previews = [];
    images &&
      images?.forEach((image) => {
        previews.push({
          blobUrl: `${process.env.REACT_APP_SPACES_IMAGE_URL}${image.image}`,
          type: "image",
          name: image.image,
        });
      });

    if (video) {
      previews = [
        ...previews,
        {
          blobUrl: `${process.env.REACT_APP_SPACES_IMAGE_URL}${video}`,
          type: "video",
          name: video,
        },
      ];
    }

    return previews;
  };

  // populate space details
  const handlePopulateInitialState = async () => {
    const spaceId = id;
    if (spaceId) {
      const result = await spaceService.fetchSpaceById(spaceId);
      if (result?.data?.spaceInfo) {
        setSpaceInfo(result.data.spaceInfo);
        setIsNeedToPrefil(true);
        // get all amenities first to create space amenities array
        let stateSpaceAmenities = [];
        const res = await amenityService.getAll();

        if (res?.data?.listAmenties) {
          stateSpaceAmenities = res.data.listAmenties.map((amenity) => ({
            isChecked: false,
            id: amenity.id,
          }));
        } else {
          console.log("Unable to amenities");
        }
        const preSelectedSpaceAmenities = getAmenitiesToBePreSelected(
          result?.data?.spaceInfo?.Amenities,
          stateSpaceAmenities
        );

        //Get All Storage Item
        let stateSpaceStorageItems = [];
        const resVehicle = await StorageItemService.getAllByCategory(2);
        if (resVehicle?.data?.storageItems?.rows) {
          stateSpaceStorageItems = resVehicle?.data?.storageItems.rows.map(
            (storedItem) => ({
              isChecked: false,
              id: storedItem.id,
            })
          );
        } else {
          console.log("Unable to Storage Item");
        }
        const preSelectedSpaceStorageItem = getVehicleTypeToBePreSelected(
          result?.data?.spaceInfo?.StorageItems,
          stateSpaceStorageItems
        );

        setFormData((prev) => ({
          ...prev,
          spaceAmenities: preSelectedSpaceAmenities,
          spaceStorageItems: preSelectedSpaceStorageItem,
          addressOne: result?.data?.spaceInfo?.addressOne
            ? result?.data?.spaceInfo?.addressOne
            : "",
          addressTwo: result?.data?.spaceInfo?.addressTwo
            ? result?.data?.spaceInfo?.addressTwo
            : "",
          stateCode: result?.data?.spaceInfo?.stateCode
            ? result?.data?.spaceInfo?.stateCode
            : "",
          city: result?.data?.spaceInfo?.city
            ? result?.data?.spaceInfo?.city
            : "",
          zipCode: result?.data?.spaceInfo?.zipCode
            ? result?.data?.spaceInfo?.zipCode
            : "",
          storageTypeId: result?.data?.spaceInfo?.storageTypeId
            ? result?.data?.spaceInfo?.storageTypeId
            : "",
          storageCategoryId: result?.data?.spaceInfo?.storageCategoryId
            ? result?.data?.spaceInfo?.storageCategoryId
            : "",
          title: result?.data?.spaceInfo?.title
            ? result?.data?.spaceInfo?.title
            : "",
          spaceLength: result?.data?.spaceInfo?.spaceLength
            ? result?.data?.spaceInfo?.spaceLength
            : "",
          quantity:
            result?.data?.spaceInfo?.quantity > 0
              ? result?.data?.spaceInfo?.quantity
              : 0,
          spaceWidth: result?.data?.spaceInfo?.spaceWidth
            ? result?.data?.spaceInfo?.spaceWidth
            : "",
          spaceHeight: result?.data?.spaceInfo?.spaceHeight
            ? result?.data?.spaceInfo?.spaceHeight
            : "",
          description: result?.data?.spaceInfo?.description
            ? result?.data?.spaceInfo?.description
            : "",
          propertyType: result?.data?.spaceInfo?.propertyType
            ? result?.data?.spaceInfo?.propertyType
            : "",
          businessType: result?.data?.spaceInfo?.businessType
            ? result?.data?.spaceInfo?.businessType
            : "",
          nearbyLandmark: result?.data?.spaceInfo?.nearbyLandmark
            ? result?.data?.spaceInfo?.nearbyLandmark
            : "",
          accessFrequency: result?.data?.spaceInfo?.accessFrequency
            ? result?.data?.spaceInfo?.accessFrequency
            : "",
          approvalOnVisit: result?.data?.spaceInfo?.approvalOnVisit,
          discountForFirstMonth: result?.data?.spaceInfo?.discountForFirstMonth
            ? result?.data?.spaceInfo?.discountForFirstMonth === 1
            : false,
          weeklyRate:
            convertStringToInt(result?.data?.spaceInfo?.weeklyRate) === 0
              ? ""
              : result?.data?.spaceInfo?.weeklyRate,
          dailyRate:
            convertStringToInt(result?.data?.spaceInfo?.dailyRate) === 0
              ? ""
              : result?.data?.spaceInfo?.dailyRate,
          monthlyRate:
            convertStringToInt(result?.data?.spaceInfo?.monthlyRate) === 0
              ? ""
              : result?.data?.spaceInfo?.monthlyRate,
          latitude: result?.data?.spaceInfo?.latitude,
          longitude: result?.data?.spaceInfo?.longitude,
          status: result?.data?.spaceInfo?.status,
          securityDeposit: result?.data?.spaceInfo?.securityDeposit,
          floorLoadCapacity: result?.data?.spaceInfo?.floorLoadCapacity,
          accessPoints: result?.data?.spaceInfo?.accessPoints,
          loadingDocks: result?.data?.spaceInfo?.loadingDocks,
          clearanceHeight: result?.data?.spaceInfo?.clearanceHeight,
          permissibleUses: result?.data?.spaceInfo?.permissibleUses,
          leaseOptions: result?.data?.spaceInfo?.leaseOptions,
          area: result?.data?.spaceInfo?.area,
          availableArea: result?.data?.spaceInfo?.availableArea,
          minimumLeaseableArea: result?.data?.spaceInfo?.minimumLeaseableArea,
          pricePerSqFt: result?.data?.spaceInfo?.pricePerSqFt,
          isAffiliateSpace: result?.data?.spaceInfo?.isAffiliateSpace,
          affiliateUrl: result?.data?.spaceInfo?.affiliateUrl ?? null,
          accessDetails: result?.data?.spaceInfo?.accessDetails,
          averageRating: result?.data?.spaceInfo?.averageRating,
          totalRatings: result?.data?.spaceInfo?.totalRatings,
          mapImage: result?.data?.spaceInfo?.mapImage,
        }));
        const previews = handlePopulateImageVideoPreview(
          result?.data?.spaceInfo?.SpaceImages,
          result?.data?.spaceInfo?.video
        );
        setSelectedImageVideoPreviews(previews);
      } else {
        toast.error("Failed to fetch space information");
        console.log("Failed to fetch space info", result);
      }
    }
  };

  const handleShowBackdropImage = (selectedImage) => {
    dispatch(showImageBackdrop(selectedImage));
  };
  const handleShowBackdropVideo = (selectedVideo) => {
    dispatch(showVideoBackdrop(selectedVideo));
  };

  const fetchStorageTypes = async () => {
    const result = await storageTypeService.getAll();
    if (result?.data?.listStorageTypes) {
      setStorageTypes(result?.data?.listStorageTypes?.rows);
    } else {
      console.log("Unable to fetch country list");
    }
  };

  const fetchStorageCategories = async () => {
    const result = await storageCategoryService.getAll();
    if (result?.data?.storageCategories) {
      setStorageCategories(result?.data?.storageCategories?.rows);
    } else {
      console.log("Unable to fetch storage categories list");
    }
  };

  const fetchAmenities = async () => {
    const res = await amenityService.getAll();
    if (res?.data?.listAmenties) {
      setAmenities(res?.data?.listAmenties);
    } else {
      console.log("Unable to fetch country list");
    }
  };

  const handleOnChange = (position, amenity) => {
    const updatedCheckedState = formData.spaceAmenities.map((item, index) => {
      if (item.id === amenity.id) {
        item.isChecked = !item.isChecked;
      }
      return item;
    });

    setFormData((prev) => ({ ...prev, spaceAmenities: updatedCheckedState }));
    const errorObj = validate("spaceAmenities", updatedCheckedState, formError); // this is for validation on change inputs
    setFormError({ ...errorObj });
  };

  const fetchVehicleType = async () => {
    const resVehicle = await StorageItemService.getAllByCategory(2);
    if (resVehicle?.data?.storageItems?.rows) {
      setVehicleType(resVehicle?.data?.storageItems?.rows);
    } else {
      console.log("Unable to fetch Vehicle list");
    }
  };

  const handleOnChangeVehicleType = (position, vehicle) => {
    const updatedCheckedState = formData.spaceStorageItems.map(
      (item, index) => {
        if (item.id === vehicle.id) {
          item.isChecked = !item.isChecked;
        }
        return item;
      }
    );

    setFormData((prev) => ({
      ...prev,
      spaceStorageItems: updatedCheckedState,
    }));
    const errorObj = validate(
      "spaceStorageItems",
      updatedCheckedState,
      formError
    ); // this is for validation on change inputs
    setFormError({ ...errorObj });
  };

  useEffect(() => {
    fetchStorageTypes();
    fetchStorageCategories();
    fetchAmenities();
    fetchVehicleType();
  }, []);

  const getIsChecked = (spaceAmenities, amenity) => {
    const amenityStatusInSpace = spaceAmenities?.find(
      (am) => am.id === amenity.id
    );
    return amenityStatusInSpace?.isChecked;
  };

  const getIsCheckedVehicleType = (spaceStorageItems, vehicleType) => {
    const vehicleTypeStatusInSpace = spaceStorageItems?.find(
      (am) => am.id === vehicleType.id
    );
    return vehicleTypeStatusInSpace?.isChecked;
  };

  useEffect(() => {
    handlePopulateInitialState();
    setMySpaceId(id);
  }, [id, refresh]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Handle character limits for title and description fields
    if (name === "title" && value?.length > 100) return;
    // if (name === "description" && value?.length > 1000) return;

    if (name === "quantity") {
      // Remove all leading zeros from the input
      const cleanedValue = value.replace(/^0+/, "");

      // If cleaned value becomes empty, default to '1'
      const validatedQuantity = Math.max(1, parseInt(cleanedValue || "1", 10));

      // Update the input field with the validated quantity
      // Assuming you have a way to set the input value, e.g., via ref or controlled component
      e.target.value = validatedQuantity; // Update the UI immediately

      // Update form data with the validated quantity
      setFormData((prev) => ({ ...prev, quantity: validatedQuantity }));

      // Validate the quantity field
      const errorObj = validate(name, validatedQuantity, formError);
      setFormError({ ...errorObj });

      return;
    }

    // Set form data for other fields
    setFormData((prev) => ({ ...prev, [name]: value }));

    // Handle specific validation for weeklyRate and monthlyRate
    if (name === "weeklyRate" || name === "monthlyRate") {
      const errorObj = validate(
        "rate",
        {
          weeklyRate: name === "weeklyRate" ? value : formData.weeklyRate,
          monthlyRate: name === "monthlyRate" ? value : formData.monthlyRate,
          dailyRate: name === "dailyRate" ? value : formData.dailyRate,
        },
        formError
      );
      setFormError({ ...errorObj });
      return;
    }

    // General validation for other fields
    const errorObj = validate(name, value, formError, formData?.businessType);
    setFormError({ ...errorObj });
  };
  //  console.log(formData,"dddd");

  const getSettings = async () => {
    try {
      const response = await settingService.getAll();
      if (response.data.listSettings.length > 0) {
        setSettings(response.data.listSettings);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getSettings();
  }, []);

  const resetStorageType = async () => {
    setFormData((prev) => ({ ...prev, storageTypeId: "" }));
  };

  const validateForm = () => {
    const err = createSpacesValidationForm(formData); // this is for whole form validation
    setFormError({ ...err });

    if (!formData.businessType) {
      err.businessType = "Business type is required.";
    }

    let isValid = true;
    for (const property in err) {
      if (err[property]) {
        // if any single error is there
        isValid = false;
        break;
      }
    }
    return isValid;
  };

  // Submit for review
  const handleSubmit = async (e) => {
    try {
      setLoading(true);

      e.preventDefault();
      setIsSubmitting(true);
      console.log("Form Data:", formData); // Log form data
      console.log("Form Errors:", formError);
      // do all address field checkings
      const allErrors = {};
      for (const fieldName in formData) {
        const fieldErrors = validateSpaceAddressFields(
          fieldName,
          formData[fieldName]
        );
        if (fieldErrors.length > 0) {
          allErrors[fieldName] = fieldErrors;
        }
      }

      // Check USPS address check
      // const result = await globalService.getVerifyAddress(formData.zipCode);
      // if (result?.data?.verifyAddress?.zipCode?.error?.description) {
      //   setUspsError(result?.data?.verifyAddress?.zipCode?.error?.description);
      //   // allErrors.zipCode = [`${result?.data?.verifyAddress?.zipCode?.error?.description}`];
      // } else {
      //   const { zip5, city, state } = result?.data?.verifyAddress?.zipCode;
      //   if (
      //     formData?.stateCode?.toLowerCase()?.trim() === state?.toLowerCase() &&
      //     formData?.city?.toLowerCase()?.trim() === city?.toLowerCase() &&
      //     formData?.zipCode?.trim() === zip5
      //   ) {
      //     setUspsError("");
      //     // allErrors.zipCode = ['zipCode doesnot belong to following state and city'];
      //   } else {
      //     setUspsError("Invalid city, state or zipCode");
      //     // allErrors.zipCode = ['zipCode doesnot belong to following state and city'];
      //   }
      // }

      // valid place with coordinate check
      if (formData.addressOne !== "") {
        const latLng = await getCoordinates(
          `${formData.addressOne} ${formData.city ? formData.city : ""} ${
            formData.stateCode ? formData.stateCode : ""
          } ${formData.zipCode ? formData.zipCode : ""}`
        );
        if (latLng) {
          setFormData((prev) => ({
            ...prev,
            latitude: latLng.lat,
            longitude: latLng.lng,
          }));
          setAddressInvalidError("");
        } else {
          setAddressInvalidError("Please provide a valid address");
        }
      }

      if (
        Object.keys(allErrors).length === 0 &&
        uspsError === "" &&
        addressInvalidError === ""
      ) {
        // amenities check
        if (
          formData?.spaceAmenities[0].id === 1 &&
          formData?.spaceAmenities[1].id === 2 &&
          formData?.spaceAmenities[0].isChecked &&
          formData?.spaceAmenities[1].isChecked
        ) {
          setIsSubmitting(false);

          toast.error("You can select either indoor or outdoor.");
          return;
        }

        const isValid = validateForm();
        if (isValid) {
          const myArray = [];
          const myVehicleArray = [];
          formData.spaceAmenities.forEach((el, index) => {
            if (el.isChecked === true) {
              myArray.push(el.id);
            }
          });
          formData.spaceStorageItems.forEach((el, index) => {
            if (el.isChecked === true) {
              myVehicleArray.push(el.id);
            }
          });
          if (!isValidUpload(selectedImageVideoPreviews)) {
            setIsSubmitting(false);
            return;
          }
          const body = new FormData();

          if (formData?.spaceMedia || formData?.spaceMedia?.length > 0) {
            formData.spaceMedia.forEach((item, i) => {
              body.append(`spaceMedia`, formData.spaceMedia[i]);
            });
          }

          if (formData?.mapImage) {
            body.append(`mapImage`, formData?.mapImage);
          }

          if (formData.stateCode) body.append("stateCode", formData.stateCode);
          if (formData.addressOne)
            body.append("addressOne", formData.addressOne);
          if (formData.addressTwo)
            body.append("addressTwo", formData.addressTwo);
          if (formData.city) body.append("city", formData.city);
          if (formData.zipCode) body.append("zipCode", formData.zipCode);
          body.append("latitude", formData.latitude);
          body.append("longitude", formData.longitude);
          if (formData.spaceHeight)
            body.append("spaceHeight", formData.spaceHeight);
          if (formData.spaceWidth)
            body.append("spaceWidth", formData.spaceWidth);
          if (formData.quantity) body.append("quantity", formData.quantity);
          if (formData.spaceLength)
            body.append("spaceLength", formData.spaceLength);
          if (formData.propertyType)
            body.append("propertyType", formData.propertyType);
          if (formData.businessType)
            body.append("businessType", formData.businessType);
          if (formData.nearbyLandmark)
            body.append("nearbyLandmark", formData.nearbyLandmark);
          if (formData.storageTypeId)
            body.append("storageTypeId", formData.storageTypeId);
          if (formData.storageCategoryId)
            body.append("storageCategoryId", formData.storageCategoryId);
          if (formData.title) body.append("title", formData.title);
          if (formData.description)
            body.append("description", formData.description);
          if (formData.weeklyRate)
            body.append(
              "weeklyRate",
              parseFloat(formData.weeklyRate).toFixed(2)
            );
          if (formData.monthlyRate)
            body.append(
              "monthlyRate",
              parseFloat(formData.monthlyRate).toFixed(2)
            );
          if (formData.dailyRate) {
            body.append("dailyRate", parseFloat(formData.dailyRate).toFixed(2));
          }
          if (formData.accessFrequency)
            body.append("accessFrequency", formData.accessFrequency);
          if (myArray.length > 0) body.append("spaceAmenities", myArray);
          if (myVehicleArray.length > 0)
            body.append("spaceStorageItems", myVehicleArray);
          if (formData.discountForFirstMonth)
            body.append(
              "discountForFirstMonth",
              formData.discountForFirstMonth ? "1" : "0"
            );
          if (formData.approvalOnVisit)
            body.append("approvalOnVisit", formData.approvalOnVisit);
          body.append("listedFrom", formData.listedFrom);
          if (removeMedia.length > 0) body.append("removeMedia", removeMedia);

          if (parseFloat(formData.securityDeposit) >= 1) {
            body.append(
              "securityDeposit",
              parseFloat(formData.securityDeposit)
            );
          }
          /* if (parseFloat(formData.floorLoadCapacity) >= 1) {
            body.append(
              "floorLoadCapacity",
              parseFloat(formData.floorLoadCapacity)
            );
          }

          if (formData.accessPoints && formData.accessPoints.trim() !== "") {
            body.append("accessPoints", formData.accessPoints.trim());
          }

          if (parseFloat(formData.loadingDocks) >= 0) {
            body.append("loadingDocks", parseFloat(formData.loadingDocks));
          } */

          if (parseFloat(formData.averageRating) >= 0) {
            body.append("averageRating", parseFloat(formData.averageRating));
          }

          if (parseFloat(formData.totalRatings) >= 0) {
            body.append("totalRatings", parseFloat(formData.totalRatings));
          }

          /* if (parseFloat(formData.clearanceHeight) >= 1) {
            body.append(
              "clearanceHeight",
              parseFloat(formData.clearanceHeight)
            );
          }

          if (
            formData.permissibleUses &&
            formData.permissibleUses.trim() !== ""
          ) {
            body.append("permissibleUses", formData.permissibleUses.trim());
          }

          if (formData.leaseOptions && formData.leaseOptions.trim() !== "") {
            body.append("leaseOptions", formData.leaseOptions.trim());
          }
          if (formData.area && formData.area) {
            body.append("area", formData.area);
          }
          if (formData.availableArea && formData.availableArea) {
            body.append("availableArea", formData.availableArea);
          }
          if (formData.minimumLeaseableArea && formData.minimumLeaseableArea) {
            body.append("minimumLeaseableArea", formData.minimumLeaseableArea);
          }

          if (formData.pricePerSqFt && formData.pricePerSqFt) {
            body.append("pricePerSqFt", formData.pricePerSqFt);
          } */

          if (formData?.isAffiliateSpace && formData?.isAffiliateSpace) {
            body.append("isAffiliateSpace", 1);
            body.append("affiliateUrl", formData?.affiliateUrl);
          } else {
            body.append("isAffiliateSpace", 0);
            body.append("affiliateUrl", "");
          }

          body.append("accessDetails", formData.accessDetails);

          if (formData?.primaryImage) {
            body.append("primaryImage", formData?.primaryImage);
          }

          console.log(id, formData, "body and id");

          const result = await spaceService.updateSpace(id, body);
          console.log(result, "resulut");

          if (result?.data?.spaceInfo) {
            setIsSubmitting(false);
            setFormError({});
            setRemoveMedia([]);
            setFormData((prev) => ({ ...prev, spaceMedia: null }));
            setRefresh(!refresh);
            toast.success("Space updated successfully!");
          } else {
            setIsSubmitting(false);
            console.log("update space failed: ", result);
          }
        } else {
          setIsSubmitting(false);
          console.log("Please enter all the required fields!");
          toast.error("Please fix the errors to submit!");
        }
      } else {
        // Validation errors, display them
        setAddressErrors(allErrors);
        toast.error("Please complete the form to submit!");
        setIsSubmitting(false);
      }
    } catch (err) {
      console.error(err);
      toast.error("Unable to save the space");
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageContainer
      pageTitleIcon="pe-7s-home icon-gradient bg-plum-plate"
      pageHeading="Edit Space"
      pageSubTitle="Edit details of a space"
    >
      <Row>
        <Col md="12">
          <Card className="main-card mb-3 p-3">
            <CardBody>
              <Row xs="1" sm="2" md="3">
                <Col md="5">
                  <EditListingSpaceImageVideoUpload
                    spaceId={id}
                    formData={formData}
                    setFormData={setFormData}
                    selectedImageVideoPreviews={selectedImageVideoPreviews}
                    setSelectedImageVideoPreviews={
                      setSelectedImageVideoPreviews
                    }
                    removeMedia={removeMedia}
                    setRemoveMedia={setRemoveMedia}
                    isDisabledEverything={isDisabledEverything}
                  />
                </Col>

                <Col md="5">
                  <SpaceAddress
                    formData={formData}
                    setFormData={setFormData}
                    uspsError={uspsError}
                    setUspsError={setUspsError}
                    addressErrors={addressErrors}
                    setAddressErrors={setAddressErrors}
                    addressInvalidError={addressInvalidError}
                    setAddressInvalidError={setAddressInvalidError}
                    isPrepopulated={isPrepopulated}
                    setIsPrepopulated={setIsPrepopulated}
                  />
                </Col>
              </Row>
              <Row xs="1" sm="2" md="3">
                <Col md="12" className="mb-4">
                  <h5 className={styles.header}>Basic information</h5>
                </Col>
                <Col md="5">
                  <div className="mb-4">
                    <h6 className={styles.header}>Storage Type Offered</h6>
                    <select
                      name="storageCategoryId"
                      id="storageCategoryId"
                      className="mb-1 form-control-custom form-select"
                      onChange={(event) => {
                        handleInputChange(event);
                        resetStorageType(); // reset the storage type on category change
                      }}
                      value={formData.storageCategoryId}
                      disabled={isDisabledEverything}
                    >
                      <option value="">Select Type</option>
                      {(!storageCategories ||
                        storageCategories.length === 0) && (
                        <option>No options to select from</option>
                      )}
                      {storageCategories &&
                        storageCategories?.map((option) => {
                          if (option?.isActive === 1) {
                            return (
                              <option key={option.id} value={option.id}>
                                {option.name}
                              </option>
                            );
                          } else {
                            return null;
                          }
                        })}
                    </select>
                    {formError?.storageCategoryId && (
                      <span className="error">
                        {formError?.storageCategoryId}
                      </span>
                    )}
                  </div>
                  <div className="mb-4">
                    <h6 className={styles.header}>Property Type</h6>
                    <select
                      name="propertyType"
                      id="propertyType"
                      className="mb-1 form-control-custom form-select"
                      onChange={handleInputChange}
                      value={formData.propertyType}
                      disabled={isDisabledEverything}
                    >
                      <option value="">Select Property Type</option>
                      {(!propertyTypes || propertyTypes.length === 0) && (
                        <option>No options to select from</option>
                      )}
                      {propertyTypes &&
                        propertyTypes.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.name}
                          </option>
                        ))}
                    </select>
                    {formError?.propertyType && (
                      <span className="error">{formError.propertyType}</span>
                    )}
                  </div>

                  <div className="mb-4">
                    <h6 className={styles.header}>Listing Title</h6>
                    <input
                      type="text"
                      name="title"
                      className="mb-1 form-control form-control-custom"
                      id="title"
                      placeholder="Enter Listing title"
                      value={formData.title}
                      onChange={handleInputChange}
                      disabled={isDisabledEverything}
                    />
                    <span className="messageInfo">
                      {formData.title?.length}/100
                    </span>
                    {formError?.title && (
                      <span className="error ms-1">{formError.title}</span>
                    )}
                  </div>
                </Col>
                <Col md="5">
                  <div className="mb-4">
                    <h6 className={styles.header}>Space Type</h6>
                    <select
                      name="storageTypeId"
                      id="storageTypeId"
                      className="mb-1 form-control-custom form-select"
                      onChange={handleInputChange}
                      value={formData.storageTypeId}
                      disabled={isDisabledEverything}
                    >
                      <option value="">Select Type</option>
                      {(!storageTypes || storageTypes.length === 0) && (
                        <option>No options to select from</option>
                      )}
                      {storageTypes &&
                        storageTypes?.map((option) => {
                          if (
                            option?.isActive === 1 &&
                            option.storageCategoryId &&
                            option.storageCategoryId ==
                              formData?.storageCategoryId
                          ) {
                            return (
                              <option key={option.id} value={option.id}>
                                {option.name}
                              </option>
                            );
                          } else {
                            return null;
                          }
                        })}
                    </select>
                    {formError?.storageTypeId && (
                      <span className="error">{formError?.storageTypeId}</span>
                    )}
                  </div>
                  {/* {formData.propertyType === "2" && */}
                  <div className="mb-4">
                    <h6 className={styles.header}>Business Type</h6>
                    <select
                      name="businessType"
                      id="businessType"
                      className="mb-1 form-control-custom form-select"
                      onChange={handleInputChange}
                      value={formData.businessType}
                      disabled={isDisabledEverything}
                    >
                      {console.log(formData.businessType, "busss")}
                      <option value="">Select Business Type</option>
                      {BUSINESS_TYPES.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.name}
                        </option>
                      ))}
                    </select>
                    {formError?.businessType && (
                      <span className="error">{formError.businessType}</span>
                    )}
                  </div>
                  {/* } */}
                  <Row xs="1" sm="2" md="4">
                    <Col md="6">
                      <h6 className={styles.header}>Space Length(ft)</h6>
                      <input
                        type="number"
                        min={1}
                        max={500}
                        name="spaceLength"
                        className="form-control form-control-custom mb-1"
                        id="spaceLength"
                        placeholder="Value"
                        value={formData.spaceLength}
                        onChange={handleInputChange}
                        disabled={isDisabledEverything}
                      />
                      {formError?.spaceLength && (
                        <span className="error">{formError.spaceLength}</span>
                      )}
                    </Col>
                    <Col md="6">
                      <h6 className={styles.header}>Space Width(ft)</h6>
                      <input
                        type="number"
                        min={1}
                        max={500}
                        name="spaceWidth"
                        className="form-control form-control-custom mb-1"
                        id="spaceWidth"
                        placeholder="Value"
                        value={formData.spaceWidth}
                        onChange={handleInputChange}
                        disabled={isDisabledEverything}
                      />
                      {formError?.spaceWidth && (
                        <span className="error">{formError.spaceWidth}</span>
                      )}
                    </Col>
                    <Col md="6">
                      <h6 className={styles.header}>Space Height(ft)</h6>
                      <input
                        type="number"
                        min={1}
                        max={100}
                        name="spaceHeight"
                        className="form-control form-control-custom mb-1"
                        id="spaceHeight"
                        placeholder="Value"
                        value={formData.spaceHeight}
                        onChange={handleInputChange}
                        disabled={isDisabledEverything}
                      />
                      {formError?.spaceHeight && (
                        <span className="error">{formError.spaceHeight}</span>
                      )}
                    </Col>
                    {/* <Col md="6">
                      <h6 className={styles.header}>Total Area (Sq.ft.)</h6>
                      <input
                        type="number"
                        min={0}
                        max={1000000}
                        name="area"
                        className="form-control form-control-custom mb-1"
                        id="area"
                        placeholder="Value"
                        value={formData.area}
                        onChange={handleInputChange}
                        disabled={isDisabledEverything}
                      />
                      {formError?.area && (
                        <span className="error">{formError.area}</span>
                      )}
                    </Col> */}

                    {/* <Col md="6">
                      <h6 className={styles.header}>Available Area (Sq.ft.)</h6>
                      <input
                        type="number"
                        min={0}
                        max={1000000}
                        name="availableArea"
                        className="form-control form-control-custom mb-1"
                        id="availableArea"
                        placeholder="Value"
                        value={formData.availableArea}
                        onChange={handleInputChange}
                        disabled={isDisabledEverything}
                      />
                      {formError?.availableArea && (
                        <span className="error">{formError.availableArea}</span>
                      )}
                    </Col>

                    <Col md="6">
                      <h6 className={styles.header}>
                        Minimum Leaseable Area (Sq.ft.)
                      </h6>
                      <input
                        type="number"
                        min={0}
                        max={1000000}
                        name="minimumLeaseableArea"
                        className="form-control form-control-custom mb-1"
                        id="minimumLeaseableArea"
                        placeholder="Value"
                        value={formData.minimumLeaseableArea}
                        onChange={handleInputChange}
                        disabled={isDisabledEverything}
                      />
                      {formError?.minimumLeaseableArea && (
                        <span className="error">
                          {formError.minimumLeaseableArea}
                        </span>
                      )}
                    </Col>

                    <Col md="6">
                      <h6 className={styles.header}>Price Per Sq.ft ($)</h6>
                      <input
                        type="number"
                        min={0}
                        max={1000000}
                        name="pricePerSqFt"
                        className="form-control form-control-custom mb-1"
                        id="pricePerSqFt"
                        placeholder="Value"
                        value={formData.pricePerSqFt}
                        onChange={handleInputChange}
                        disabled={isDisabledEverything}
                      />
                      {formError?.pricePerSqFt && (
                        <span className="error">{formError.pricePerSqFt}</span>
                      )}
                    </Col> */}

                    <Col md="6">
                      <h6 className={styles.header}>Quantity(Nos.)</h6>
                      <input
                        type="number"
                        min={0}
                        name="quantity"
                        className="form-control form-control-custom mb-4"
                        id="quantity"
                        placeholder="Value"
                        value={formData.quantity}
                        onChange={handleInputChange}
                        disabled={isDisabledEverything}
                      />
                      {formError?.quantity && (
                        <span className="error">{formError.quantity}</span>
                      )}
                    </Col>
                  </Row>
                </Col>
                {false && formData.businessType == "9" && (
                  <Col md="12">
                    {/* First Row with 4 columns */}
                    <Row>
                      <Col md="3" className="mb-3">
                        <h6 className={styles.header}>
                          Floor Load Capacity (lbs/sq ft)
                        </h6>
                        <input
                          type="number"
                          min={0}
                          name="floorLoadCapacity"
                          className="form-control form-control-custom mb-1"
                          placeholder="Enter Floor Load Capacity"
                          value={formData.floorLoadCapacity}
                          onChange={handleInputChange}
                          disabled={isDisabledEverything}
                        />
                        {formError?.floorLoadCapacity && (
                          <span className="error">
                            {formError.floorLoadCapacity}
                          </span>
                        )}
                      </Col>

                      <Col md="3" className="mb-3">
                        <h6 className={styles.header}>
                          Number of Loading Docks
                        </h6>
                        <input
                          type="number"
                          min={0}
                          name="loadingDocks"
                          className="form-control form-control-custom mb-1"
                          placeholder="Enter Number of Loading Docks"
                          value={formData.loadingDocks}
                          onChange={handleInputChange}
                          disabled={isDisabledEverything}
                        />
                        {formError?.loadingDocks && (
                          <span className="error">
                            {formError.loadingDocks}
                          </span>
                        )}
                      </Col>

                      <Col md="4" className="mb-4">
                        <h6 className={styles.header}>Clearance Height (ft)</h6>
                        <input
                          type="number"
                          min={0}
                          step={0.1}
                          name="clearanceHeight"
                          className="form-control form-control-custom mb-1"
                          placeholder="Enter Clearance Height"
                          value={formData.clearanceHeight}
                          onChange={handleInputChange}
                          disabled={isDisabledEverything}
                        />
                        {formError?.clearanceHeight && (
                          <span className="error">
                            {formError.clearanceHeight}
                          </span>
                        )}
                      </Col>
                    </Row>
                    {/* Second Row with 4 columns */}
                    <Row>
                      <Col md="3" className="mb-3">
                        <h6 className={styles.header}>Access Points</h6>
                        <textarea
                          name="accessPoints"
                          className="form-control form-control-custom mb-1"
                          placeholder="Describe Access Points"
                          rows="3"
                          value={formData.accessPoints}
                          onChange={handleInputChange}
                          disabled={isDisabledEverything}
                        ></textarea>
                        <span className="messageInfo">
                          {formData.accessPoints?.length}/500
                        </span>
                        {formError?.accessPoints && (
                          <span className="error">
                            {formError.accessPoints}
                          </span>
                        )}
                      </Col>

                      <Col md="3" className="mb-3">
                        <h6 className={styles.header}>Permissible Uses</h6>
                        <textarea
                          name="permissibleUses"
                          className="form-control form-control-custom mb-1"
                          placeholder="Describe Permissible Uses"
                          rows="3"
                          value={formData.permissibleUses}
                          onChange={handleInputChange}
                          disabled={isDisabledEverything}
                        ></textarea>
                        <span className="messageInfo">
                          {formData.permissibleUses?.length}/500
                        </span>
                        {formError?.permissibleUses && (
                          <span className="error">
                            {formError.permissibleUses}
                          </span>
                        )}
                      </Col>

                      <Col md="4" className="mb-4">
                        <h6 className={styles.header}>Lease Options</h6>
                        <select
                          name="leaseOptions"
                          id="leaseOptions"
                          className="form-select"
                          value={formData.leaseOptions || ""}
                          onChange={handleInputChange}
                          disabled={isDisabledEverything}
                        >
                          <option value="">Select Lease Option</option>
                          {leaseOptions && leaseOptions.length > 0 ? (
                            leaseOptions.map((option) => (
                              <option
                                key={option.id}
                                value={String(option.label)}
                              >
                                {option.label}
                              </option>
                            ))
                          ) : (
                            <option disabled>No lease options available</option>
                          )}
                        </select>
                        {formError?.leaseOptions && (
                          <span className="error">
                            {formError.leaseOptions}
                          </span>
                        )}
                      </Col>
                    </Row>
                  </Col>
                )}

                <Col md="12">
                  <Row>
                    <Col md="10 mb-4">
                      <h6 className={styles.header}>Listing Description</h6>
                      <textarea
                        name="description"
                        id="description"
                        className="mb-1 form-control-custom form-control"
                        placeholder="Enter Details"
                        rows="4"
                        onChange={handleInputChange}
                        value={formData.description}
                        disabled={isDisabledEverything}
                      ></textarea>
                      {/* <span className="messageInfo">
                        {formData.description?.length}/1000
                      </span> */}
                      {formError?.description && (
                        <span className="error ms-1">
                          {formError.description}
                        </span>
                      )}
                    </Col>
                    {formData.storageCategoryId == 2 ? (
                      <Col md="10" className="mb-4">
                        <h6 className={styles.header}>
                          Listing Vehicle Type Features
                        </h6>
                        <ul className="option-select d-inline-flex flex-wrap">
                          {vehicleType &&
                            vehicleType.map((vehicle, index) => (
                              <li
                                key={vehicle.id}
                                className="option-select-list m-2 d-flex align-items-cnter"
                              >
                                <input
                                  type="checkbox"
                                  // checked={isChecked(amenity)}
                                  id={`vehicle-checkbox-${index}`}
                                  checked={getIsCheckedVehicleType(
                                    formData?.spaceStorageItems,
                                    vehicle
                                  )}
                                  onChange={() =>
                                    handleOnChangeVehicleType(index, vehicle)
                                  }
                                  disabled={isDisabledEverything}
                                />
                                <label
                                  className="option-select-label"
                                  htmlFor={`vehicle-checkbox-${index}`}
                                  style={{ overflow: "hidden" }}
                                >
                                  <img
                                    src={`${process.env.REACT_APP_VEHICLE_IMAGE_URL}${vehicle.image}`}
                                    alt=""
                                    style={{ width: "18px" }}
                                    className="m-1"
                                  />
                                  <span className="option-select-title">
                                    {vehicle.item}
                                  </span>
                                </label>
                              </li>
                            ))}
                          {formError?.spaceStorageItems && (
                            <span className="error">
                              {formError.spaceStorageItems}
                            </span>
                          )}
                        </ul>
                      </Col>
                    ) : null}
                    <Row>
                      <Col md="12">
                        <SpaceImageUpload
                          formData={formData}
                          setFormData={setFormData}
                        />
                      </Col>
                    </Row>
                    <Col md="10 mb-4">
                      <h6 className={styles.header}>Access Details</h6>
                      <textarea
                        name="accessDetails"
                        id="accessDetails"
                        className="mb-1 form-control-custom form-control"
                        placeholder="Enter Access Details"
                        rows="4"
                        onChange={handleInputChange}
                        value={formData.accessDetails}
                        disabled={isDisabledEverything}
                      ></textarea>
                      {/* <span className="messageInfo">
                        {formData.description?.length}/500
                      </span> */}
                      {formError?.accessDetails && (
                        <span className="error ms-1">
                          {formError.accessDetails}
                        </span>
                      )}
                    </Col>
                    <Col md="10" className="mb-4">
                      <h6 className={styles.header}>Listing Features</h6>
                      <ul className="option-select d-inline-flex flex-wrap">
                        {amenities &&
                          amenities.map((amenity, index) => (
                            <li
                              key={amenity.id}
                              className="option-select-list m-2 d-flex align-items-cnter"
                            >
                              <input
                                type="checkbox"
                                // checked={isChecked(amenity)}
                                id={`amenity-checkbox-${index}`}
                                checked={getIsChecked(
                                  formData?.spaceAmenities,
                                  amenity
                                )}
                                onChange={() => handleOnChange(index, amenity)}
                                disabled={isDisabledEverything}
                              />
                              <label
                                className="option-select-label"
                                htmlFor={`amenity-checkbox-${index}`}
                                style={{ overflow: "hidden" }}
                              >
                                <img
                                  src={`${process.env.REACT_APP_AMENITIES_IMAGE_URL}${amenity.image}`}
                                  alt=""
                                  style={{ width: "18px" }}
                                  className="m-1"
                                />
                                <span className="option-select-title">
                                  {amenity.name}
                                </span>
                              </label>
                            </li>
                          ))}
                        {formError?.spaceAmenities && (
                          <span className="error">
                            {formError.spaceAmenities}
                          </span>
                        )}
                      </ul>
                    </Col>
                  </Row>
                </Col>
                <Col md="12">
                  <Row>
                    <Col md="10 mt-3">
                      <h6 className={styles.header}>Access Frequency</h6>
                      <div
                        style={{
                          backgroundColor: "#F3F6FF",
                          padding: 20,
                          borderRadius: 5,
                        }}
                      >
                        <Form.Group className="d-flex justify-content-between">
                          {accessFrequencyList &&
                            accessFrequencyList.map((acc) => (
                              <div
                                key={acc.id}
                                className="form-check radio-check form-check-inline"
                              >
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="accessFrequency"
                                  id={`accessFrequency${acc.id}`}
                                  value={acc.id}
                                  // eslint-disable-next-line eqeqeq
                                  checked={acc.id == formData?.accessFrequency}
                                  // defaultChecked={parseInt(acc.id) === parseInt(formData?.accessFrequency)}
                                  onChange={handleInputChange}
                                  disabled={isDisabledEverything}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`accessFrequency${acc.id}`}
                                >
                                  {acc.label}
                                </label>
                              </div>
                            ))}
                        </Form.Group>
                      </div>
                    </Col>
                    <Col md="10 mt-3 ms-3">
                      <h6 className={styles.header}>
                        Nearby Landmark/Intersection
                      </h6>
                      <div className="mb-4">
                        <input
                          type="text"
                          name="nearbyLandmark"
                          className="mb-1 form-control form-control-custom"
                          id="nearbyLandmark"
                          placeholder="Enter Nearby Landmark/Intersection"
                          value={formData.nearbyLandmark}
                          onChange={handleInputChange}
                          disabled={isDisabledEverything}
                        />
                        <span className="messageInfo">
                          {formData.nearbyLandmark?.length}/100
                        </span>
                        {formError?.nearbyLandmark && (
                          <span className="error ms-1">
                            {formError.nearbyLandmark}
                          </span>
                        )}
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col md="12" className="mb-4">
                  <h5 className={styles.header}>Rental Type</h5>
                </Col>
                <Col md="5">
                  <div
                    style={{
                      backgroundColor: "#F3F6FF",
                      padding: 20,
                      borderRadius: 5,
                    }}
                  >
                    <Row xs="1" sm="2" md="3">
                      <Col md="6">
                        <h6>Weekly</h6>
                        <input
                          type="number"
                          className="mb-4 form-control-custom form-control"
                          placeholder="Weekly rate"
                          id="weekly"
                          name="weeklyRate"
                          onChange={handleInputChange}
                          value={formData.weeklyRate}
                          disabled={isDisabledEverything}
                        />
                      </Col>
                      <Col md="6">
                        <h6>Monthly</h6>
                        <input
                          type="number"
                          className="mb-4 form-control-custom form-control"
                          placeholder="Monthly price"
                          id="monthly"
                          name="monthlyRate"
                          onChange={handleInputChange}
                          value={formData.monthlyRate}
                          disabled={isDisabledEverything}
                        />
                      </Col>
                      <Col md="6">
                        <h6>Daily</h6>
                        <input
                          type="number"
                          className="mb-4 form-control-custom form-control"
                          placeholder="Daily price"
                          id="daily"
                          name="dailyRate"
                          onChange={handleInputChange}
                          value={formData.dailyRate}
                          disabled={isDisabledEverything}
                        />
                      </Col>
                      {formError?.rate && (
                        <span className="error">{formError?.rate}</span>
                      )}
                      <Col md="10">
                        <span className="yes-toggle-text">
                          Offer a{" "}
                          <strong>
                            {
                              getSettingsConfig(
                                settings,
                                "firstMonthDiscountPercent"
                              )?.configValue
                            }
                            % discount
                          </strong>{" "}
                          for the <strong>First Rental Period?</strong>
                        </span>
                      </Col>
                      <Col md="2">
                        <div className="yes-toggle">
                          <div className="form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="discountForFirstMonth"
                              name="discountForFirstMonth"
                              checked={formData.discountForFirstMonth}
                              onChange={() => {
                                setFormData((prev) => ({
                                  ...prev,
                                  discountForFirstMonth:
                                    !formData.discountForFirstMonth,
                                }));
                              }}
                              disabled={isDisabledEverything}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="discountForFirstMonth"
                            >
                              Yes
                            </label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <Col className="mt-3 mb-3">
                    <h6 className={styles.header}>One Time Security Deposit</h6>
                  </Col>
                  <div
                    style={{
                      backgroundColor: "#F3F6FF",
                      padding: 20,
                      borderRadius: 5,
                    }}
                  >
                    <Col>
                      <div className="mb-4">
                        <h6 className={styles.header}>Security Deposit</h6>
                        <input
                          type="number"
                          className="form-control mb-1 form-control-custom"
                          placeholder="Enter the amount"
                          id="securityDeposit"
                          name="securityDeposit"
                          onChange={handleInputChange}
                          value={formData.securityDeposit}
                          disabled={isDisabledEverything}
                        />
                        {formError?.securityDeposit && (
                          <span className="error">
                            {formError?.securityDeposit}
                          </span>
                        )}
                      </div>
                      <h6>
                        Not requiring a security deposit can increase the
                        likelihood of your space being booked quickly
                      </h6>
                    </Col>
                  </div>
                </Col>
                <Col md="5">
                  <Col className="mt-3">
                    <h6 className={styles.header}>
                      Should approved renters contact you before each visit ?
                    </h6>
                    <div
                      style={{
                        backgroundColor: "#F3F6FF",
                        padding: 20,
                        borderRadius: 5,
                        marginBottom: 15,
                      }}
                    >
                      <Form.Group>
                        <div className="form-check radio-check form-check-inline mb-1">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="approvalOnVisit"
                            id="approvalOnVisit1"
                            value="1"
                            // eslint-disable-next-line eqeqeq
                            checked={"1" == formData?.approvalOnVisit}
                            onChange={handleInputChange}
                            disabled={isDisabledEverything}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="approvalOnVisit1"
                          >
                            {" "}
                            <strong>Yes</strong>, renters should contact me each
                            time
                          </label>
                        </div>
                        <div className="form-check radio-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="approvalOnVisit"
                            id="approvalOnVisit0"
                            value="0"
                            // eslint-disable-next-line eqeqeq
                            checked={"0" == formData?.approvalOnVisit}
                            onChange={handleInputChange}
                            disabled={isDisabledEverything}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="approvalOnVisit0"
                          >
                            {" "}
                            <strong>No</strong>, renters can come without any
                            appointment
                          </label>
                        </div>
                      </Form.Group>
                    </div>
                    <div
                      style={{
                        marginBottom: 15,
                      }}
                    >
                      <h6 className={styles.header}>Listing Description</h6>
                      <div className="yes-toggle">
                        <div className="form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="isAffiliateSpace"
                            name="isAffiliateSpace"
                            checked={formData.isAffiliateSpace}
                            onChange={() => {
                              setFormData((prev) => ({
                                ...prev,
                                isAffiliateSpace: !formData.isAffiliateSpace,
                              }));
                            }}
                            disabled={isDisabledEverything}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="isAffiliateSpace"
                          >
                            &nbsp; Is Affilicate Space?
                          </label>
                        </div>
                      </div>
                    </div>
                    <div>
                      <h6 className={styles.header}>Affilicate URL</h6>
                      <input
                        type="text"
                        className="form-control-custom form-control"
                        placeholder="Affiliate URL"
                        id="affiliateUrl"
                        name="affiliateUrl"
                        onChange={handleInputChange}
                        value={formData.affiliateUrl}
                        disabled={isDisabledEverything}
                      />
                      {formError?.affiliateUrl && (
                        <span className="error">{formError?.affiliateUrl}</span>
                      )}
                    </div>
                    <div className="mt-3">
                      <h6 className={styles.header}>Average Rating</h6>
                      <input
                        type="number"
                        className="form-control-custom form-control"
                        placeholder="Enter Rating"
                        id="averageRating"
                        name="averageRating"
                        onChange={handleInputChange}
                        value={formData.averageRating}
                        disabled={isDisabledEverything}
                        max={5}
                        min={0}
                      />
                      {formError?.averageRating && (
                        <span className="error">
                          {formError?.averageRating}
                        </span>
                      )}
                    </div>
                    <div className="mt-3">
                      <h6 className={styles.header}>Total Ratings</h6>
                      <input
                        type="number"
                        className="form-control-custom form-control"
                        placeholder="Enter a Number"
                        id="totalRatings"
                        name="totalRatings"
                        onChange={handleInputChange}
                        value={formData.totalRatings}
                        disabled={isDisabledEverything}
                        min={0}
                      />
                      {formError?.totalRatings && (
                        <span className="error">{formError?.totalRatings}</span>
                      )}
                    </div>
                  </Col>
                </Col>
                <Col md="12" className="mt-3">
                  {/* <Form>
                    {['checkbox'].map((type) => (
                      <div key={`inline-${type}`} className="mb-3">
                        <Form.Check
                          inline
                          label="Lead generation"
                          name="group1"
                          type={type}
                          id={`inline-${type}-1`}
                        />
                      </div>
                    ))}
                  </Form> */}
                </Col>
                <Col md="10 mt-3">
                  {loading === false ? (
                    <Button size="lg" color="primary" onClick={handleSubmit}>
                      Save
                    </Button>
                  ) : (
                    <Button size="lg" color="primary">
                      Saving..
                    </Button>
                  )}
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
      {spaceInfo?.User?.ContactFacility === 1 && (
        <Button
          variant="contained"
          color="primary"
          onClick={addhandleOpenModal}
        >
          + Add Sub Space
        </Button>
      )}
      <AddSubSpace
        open={isModalOpen}
        handleClose={addhandleCloseModal}
        amenityOptions={amenityOptions}
        listingId={id}
      >
        <p>This is the content inside the modal!</p>
      </AddSubSpace>
    </PageContainer>
  );
}
